<template>
  <b-modal
    v-model="showModal"
    scrollable
    title="Csomag vásárlása"
    ok-title="Hozzáadás"
    ok-variant="success"
    cancel-title="Mégsem"
    size="lg"
    :ok-disabled="!isValid || loading"
    @ok="save"
  >
    <loading v-model="loading" :height="500">
      <b-form-group
        label-cols="4"
        label-for="package"
      >
        <template v-slot:label>
          <toggle-details v-if="selectedPackage !== null" v-b-toggle.package-details>Csomag</toggle-details>
          <span v-if="selectedPackage === null">Csomag</span>
        </template>
        <b-select
          id="package"
          v-model="selectedPackageId"
          :options="packageList"
        />
      </b-form-group>
      <div v-if="selectedPackage !== null">
        <b-collapse id="package-details">
          <package v-if="selectedPackage !== null" :selected-package="selectedPackage"></package>
        </b-collapse>
        <b-form-group
          label-cols="4"
          label="Ár"
          label-for="price"
          :state="errors$price.length > 0 ? false : null"
          :invalid-feedback="errors$price"
        >
          <b-input-group>
            <b-form-input
              type="number"
              min="0"
              id="price"
              v-model="price"
              :state="errors$price.length > 0 ? false : null"
              readonly
            ></b-form-input>
            <b-input-group-append>
              <b-input-group-text>Ft</b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label="Havidíj"
          label-for="recurringPrice"
          :state="errors$recurring_price.length > 0 ? false : null"
          :invalid-feedback="errors$recurring_price"
        >
          <b-input-group>
            <b-form-input
              type="number"
              min="0"
              id="recurringPrice"
              v-model="recurringPrice"
              :state="errors$recurring_price.length > 0 ? false : null"
              readonly
            ></b-form-input>
            <b-input-group-append>
              <b-input-group-text>Ft</b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label="Felhasználható ettől"
          label-for="validityStartDate"
          :state="errors$validity_start.length > 0 ? false : null"
          :invalid-feedback="errors$validity_start"
        >
          <b-input-group>
            <b-form-datepicker
              id="validityStartDate"
              v-model="validityStartDate"
              v-bind="datePickerLabels"
              :state="errors$validity_start.length > 0 ? false : null"
              :date-disabled-fn="validityStartDateDisabled"
              locale="hu-HU"
              required
            ></b-form-datepicker>
          </b-input-group>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label="Felhasználható eddig"
          label-for="validityEndDate"
          :state="errors$validity_end.length > 0 ? false : null"
          :invalid-feedback="errors$validity_end"
        >
          <b-input-group>
            <b-form-datepicker
              id="validityEndDate"
              v-model="validityEndDate"
              v-bind="datePickerLabels"
              :state="errors$validity_end.length > 0 ? false : null"
              :date-disabled-fn="validityEndDateDisabled"
              locale="hu-HU"
              required
            ></b-form-datepicker>
            <b-input-group-append>
              <b-button @click="validityEndDate = ''" variant="danger" size="sm"><i class="fas fa-trash"></i></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <div class="section mt-3" v-if="selectedPackage.is_recurring">
          <div class="section-title">Próbaidőszak</div>
          <div class="section-content">
            <b-form-group
              label-cols="4"
              label="Próbaidőszak"
              label-for="isTrial"
              :state="errors$is_trial.length > 0 ? false : null"
              :invalid-feedback="errors$is_trial"
            >
              <b-checkbox
                id="isTrial"
                v-model="isTrial"
                :state="errors$is_trial.length > 0 ? false : null"
              ></b-checkbox>
            </b-form-group>
            <b-form-group
              v-if="isTrial"
              label-cols="4"
              label="Próbaidőszak vége"
              label-for="endTrialDate"
              :state="errors$schedule_end_trial.length > 0 ? false : null"
              :invalid-feedback="errors$schedule_end_trial"
            >
              <b-form-datepicker
                id="endTrialDate"
                v-model="endTrialDate"
                v-bind="datePickerLabels"
                :state="errors$schedule_end_trial.length > 0 ? false : null"
                :date-disabled-fn="endTrialDateDisabled"
                locale="hu-HU"
                required
              ></b-form-datepicker>
            </b-form-group>
            <b-form-group
              v-if="isTrial"
              label-cols="4"
              label="Ügyfél kedvezmény"
              label-for="customer_discount"
            >
              <b-input-group>
                <b-form-input
                  type="number"
                  min="0"
                  id="customer_discount"
                  :value="Math.ceil(customerDiscount * 100)"
                  readonly
                ></b-form-input>
                <b-input-group-append>
                  <b-input-group-text>%</b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group
              v-if="isTrial"
              label-cols="4"
              label="Próbaidőszak kedvezmény"
              label-for="trial_discount"
            >
              <b-input-group>
                <b-form-input
                  type="number"
                  min="0"
                  id="trial_discount"
                  :value="Math.ceil(selectedPackage.trial_discount * 100)"
                  readonly
                ></b-form-input>
                <b-input-group-append>
                  <b-input-group-text>%</b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group
              v-if="isTrial"
              label-cols="4"
              label="Próbaidőszak ár"
              label-for="trial_price"
            >
              <b-input-group>
                <b-form-input
                  type="number"
                  min="0"
                  id="trial_price"
                  :value="getDiscountedPrice(price)"
                  readonly
                ></b-form-input>
                <b-input-group-append>
                  <b-input-group-text>Ft</b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group
              v-if="isTrial"
              label-cols="4"
              label="Próbaidőszak havidíj"
              label-for="trial_recurring_price"
            >
              <b-input-group>
                <b-form-input
                  type="number"
                  min="0"
                  id="trial_recurring_price"
                  :value="getDiscountedPrice(recurringPrice)"
                  readonly
                ></b-form-input>
                <b-input-group-append>
                  <b-input-group-text>Ft</b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
        </div>
        <div class="section mt-3" v-if="selectedPackage !== null && selectedPackage.is_recurring">
          <div class="section-title">Előfizetés részletei</div>
          <div class="section-content">
            <b-form-group
              label-cols="4"
              label="Előfizetés vége"
              label-for="endDate"
              :state="errors$schedule_end.length > 0 ? false : null"
              :invalid-feedback="errors$schedule_end"
            >
              <b-input-group>
                <b-form-datepicker
                  id="endDate"
                  v-model="endDate"
                  v-bind="datePickerLabels"
                  :state="errors$schedule_end.length > 0 ? false : null"
                  :date-disabled-fn="endDateDisabled"
                  locale="hu-HU"
                  required
                ></b-form-datepicker>
              <b-input-group-append>
                  <b-button @click="endDate = ''" variant="danger" size="sm"><i class="fas fa-trash"></i></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group
              label-cols="4"
              label="Következő befizetés esedékes"
              label-for="nextPaymentDate"
              :state="errors$schedule_next_payment.length > 0 ? false : null"
              :invalid-feedback="errors$schedule_next_payment"
            >
              <b-form-datepicker
                id="nextPaymentDate"
                v-model="nextPaymentDate"
                v-bind="datePickerLabels"
                :state="errors$schedule_next_payment.length > 0 ? false : null"
                :date-disabled-fn="nextPaymentDateDisabled"
                locale="hu-HU"
              ></b-form-datepicker>
            </b-form-group>
          </div>
        </div>
      </div>
    </loading>
  </b-modal>
</template>
<script>
import moment from 'moment'

import datePickerLabels from '../common/_datePickerLabels'
import emptyCustomer from '../customer/_customer'
import { getLastDayOfMonth, getFirstDayOfNextMonth, mysqlFormatDate } from '../../utils/Date'

import Package from '../packages/Package'

import FormValidation from '../../utils/mixins/FormValidation'
import ErrorHandler from '../../utils/mixins/ErrorHandler'

import Loading from '../common/LoadingPlaceholder'
import ToggleDetails from '../common/ToggleDetails.vue'

export default {
  mixins: [
    FormValidation(['schedule_end', 'schedule_next_payment', 'schedule_end_trial', 'validity_start', 'validity_end', 'price', 'recurring_price', 'is_trial']),
    ErrorHandler()
  ],
  components: {
    'package': Package,
    'loading': Loading,
    'toggle-details': ToggleDetails
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: Number,
      required: true
    },
    customerDiscount: {
      type: Number,
      required: false,
      default: 1
    }
  },
  data() {
    return {
      datePickerLabels,
      showModal: false,
      selectedPackageId: -1,
      endDate: '',
      nextPaymentDate: '',
      validityStartDate: '',
      validityEndDate: '',
      price: 0,
      recurringPrice: 0,
      packages: [],
      loading: true,
      isTrial: false,
      endTrialDate: ''
    }
  },
  computed: {
    selectedPackage() {
      if(this.selectedPackageId !== -1) {
        var found = _.find(this.packages, currentPackage => currentPackage.id === this.selectedPackageId)
        return typeof found !== 'undefined' ? found : null
      } else {
        return null
      }
    },
    packageState() {
      return this.selectedPackageId !== -1
    },
    packageList() {
      return _.map(this.packages, option => ({
        value: option.id,
        text: `${option.name}${option.is_recurring ? ' (Előfizetés)' : ''}`
      }))
    },
    dateState() {
      return this.nextPaymentDate !== ''
    },
    isValid() {
      return this.packageState && (!this.selectedPackage.is_recurring || this.dateState)
    },
  },
  watch: {
    showModal: function(show) {
      this.$emit('update:show', show)
    },
    show: function(show) {
      if(show) {
        this.reset()
      }

      this.showModal = show
    },
    validityStartDate(date) {
      this.setValidityEndDate(date)
      this.setTrialEndDate(date)
    },
    isTrial(trial) {
      this.setTrialEndDate()
    },
    selectedPackageId: function(id, oldId) {
      if(id !== -1) {
        if(!this.selectedPackage.is_recurring) {
          this.endDate = ''
          this.nextPaymentDate = ''
        } else {
          this.nextPaymentDate = getFirstDayOfNextMonth().format(moment.HTML5_FMT.DATE)
        }

        this.price = this.selectedPackage.price
        this.recurringPrice = this.selectedPackage.recurring_price
        this.isTrial = false
        this.validityStartDate = moment().format(moment.HTML5_FMT.DATE)
        this.setValidityEndDate()

      } else {
        this.price = 0
        this.recurringPrice = 0
      }
    }
  },
  mounted() {
    this.$on('toggle', this.toggleModal)
    this.showModal = this.show
    this.loadPackages()
  },
  methods: {
    getDiscountedPrice(price) {
      // apply price reductions
      return Math.ceil(_.reduce([this.selectedPackage.trial_discount, this.customerDiscount], (price, discount) => {
        return price - (price * discount)
      }, price))
    },
    setTrialEndDate(date) {
      if(typeof date === 'undefined') {
        date = this.validityStartDate
      }

      if(this.isTrial) {
        this.endTrialDate = moment(date).add(this.selectedPackage.trial_length_months, 'months').endOf('month').format(moment.HTML5_FMT.DATE)
      } else {
        this.endTrialDate = ''
      }
    },
    setValidityEndDate(date) {
      if(typeof date === 'undefined') {
        date = this.validityStartDate
      }

      this.validityEndDate = moment(date).add(this.selectedPackage.validity_length_months, 'months').endOf('month').format(moment.HTML5_FMT.DATE)
    },
    toggleModal() {
      this.showModal = !this.showModal
    },
    reset() {
      this.selectedPackageId = -1
      this.endDate = ''
      this.nextPaymentDate = ''
      this.clearErrors()
    },
    loadPackages() {
      this.loading = true
      this.clearErrors()

      this.$http.get(this.$url('api.billing-packages.index'))
        .then(({data}) => {
          this.packages = data.packages
          this.loading = false
        })
        .catch(this.handleErrors)
    },
    save(modal) {
      modal.preventDefault()

      this.$http.post(this.$url('api.billing-purchases.store'), {
        customer_id: this.customerId,
        schedule_end: mysqlFormatDate(this.endDate),
        schedule_next_payment: mysqlFormatDate(this.nextPaymentDate),
        validity_start: mysqlFormatDate(this.validityStartDate),
        validity_end: mysqlFormatDate(this.validityEndDate),
        package_id: this.selectedPackageId,
        price: this.price,
        is_trial: this.isTrial,
        schedule_end_trial: mysqlFormatDate(this.endTrialDate)
      })
      .then(({data}) => {
        this.showModal = false

        this.$root.$emit('purchase', {...data})
      })
      .catch(this.handleErrors)
    },
    endDateDisabled(date) {
      var current = moment(date)
      var last = getLastDayOfMonth(current)
      var nextPayment = moment(this.nextPaymentDate)

      return current.isBefore(moment(), 'day') || current.isBefore(nextPayment, 'day') || current.date() !== last.date()
    },
    endTrialDateDisabled(date) {
      var current = moment(date)
      var last = getLastDayOfMonth(current)
      var end = moment(this.endDate)

      return current.isBefore(moment(), 'day') || current.isBefore(end, 'day') || current.date() !== last.date()
    },
    nextPaymentDateDisabled(date) {
      var current = moment(date)
      var end = moment(this.endDate)

      return current.isAfter(end, 'day') || current.date() !== 1
    },
    validityStartDateDisabled(date) {
      var current = moment(date)
      var end = moment(this.endDate)
      var now = moment()

      return current.isBefore(now, 'day') || (end.isValid() && current.isBefore(end, 'day'))
    },
    validityEndDateDisabled(date) {
      var current = moment(date)
      var end = moment(this.endDate)
      var validityStart = moment(this.validityStartDate)
      var last = getLastDayOfMonth(current)

      return current.isBefore() || current.isBefore(end) || current.isSameOrBefore(validityStart) || current.date() !== last.date()
    },
  }
}
</script>